// ============================================================
// BLOQ MƏZMUNU
// ------------------------------------------------------------
// Məqalələr Azərbaycan dilindədir — auditoriya yerlidir.
// Yeni məqalə əlavə etmək: massivin BAŞINA yeni obyekt yaz.
//
// body blokları:
//   { type: 'p',  text: '...' }              — paraqraf
//   { type: 'h',  text: '...' }              — alt başlıq
//   { type: 'ul', items: ['...', '...'] }    — siyahı
//   { type: 'q',  text: '...' }              — vurğulanmış sitat
// ============================================================

export const blogPosts = [
  {
    slug: 'olcu-secimi-evde-olcu-almaq',
    title: 'Onlayn geyim alanda ölçünü səhv seçməmək üçün',
    category: 'Bələdçi',
    date: '2026-09-12',
    excerpt:
      'Onlayn alış-verişdə qaytarmaların əksəriyyəti bir səbəbdən olur — ölçü. Evdə düzgün ölçü almaq üç dəqiqə çəkir və bir dəfə etsən, bütün sonrakı sifarişlərdə işinə yarayır.',
    body: [
      {
        type: 'p',
        text: 'Onlayn geyim alarkən ən çox rast gəlinən problem parçanın keyfiyyəti və ya rəng deyil — ölçüdür. Mağazada paltarı əynində sınayırsan, onlayn isə yalnız rəqəmlərə güvənməli olursan. Yaxşı xəbər budur ki, bir dəfə düzgün ölçü alsan, onu telefonunda saxlayıb hər sifarişdə istifadə edə bilərsən.',
      },
      { type: 'h', text: 'Nə lazımdır' },
      {
        type: 'p',
        text: 'Yumşaq santimetr lenti. Əgər yoxdursa, bir ip parçası və düz xətkeş də işə yarayır: ipi bədənə dolayır, işarələyir, sonra xətkeşlə ölçürsən. Ölçü alarkən nazik paltarda ol, üst-üstə geyim olmasın.',
      },
      { type: 'h', text: 'Dörd əsas ölçü' },
      {
        type: 'ul',
        items: [
          'Sinə: sinənin ən qabarıq yerindən, lent yerə paralel olmaqla. Dərin nəfəs almadan, adi vəziyyətdə.',
          'Bel: bədənin ən nazik yeri — adətən göbəkdən 2–3 sm yuxarı. Lenti sıxma, barmağın rahat girməlidir.',
          'Omba: ombanın ən geniş yerindən, ayaqlar bitişik vəziyyətdə.',
          'Uzunluq: çiyindən aşağı — donun nə qədər uzun olmasını istədiyini bil. Bu, xüsusilə midi və maksi modellərdə vacibdir.',
        ],
      },
      {
        type: 'q',
        text: 'Lenti həmişə bədənə toxunacaq qədər, amma sıxmadan tut. Sıxılmış lent 2–3 sm səhv verir, bu isə bir ölçü fərqi deməkdir.',
      },
      { type: 'h', text: 'Ölçü cədvəli ilə müqayisə' },
      {
        type: 'p',
        text: 'Ölçülərin iki ölçü arasına düşürsə, parçanın növünə bax. Elastik parçada (viskoz qarışığı, trikotaj) kiçik ölçünü seç — parça özünü uzadacaq. Sərt parçada (kətan, qalın pambıq, kostyum parçası) böyük ölçünü seç — çünki o, uzanmır və hərəkəti məhdudlaşdırar.',
      },
      {
        type: 'p',
        text: 'Kəmərli modellərdə bel ölçüsü ən vacibdir, sinə və omba isə bir az geniş ola bilər. Düz kəsimli donlarda ən geniş ölçünə görə seç — çünki o hissə keçməsə, paltar geyilmir.',
      },
      { type: 'h', text: 'Ölçünü bir dəfə yaz, hər dəfə istifadə et' },
      {
        type: 'p',
        text: 'Aldığın dörd rəqəmi telefonun qeydlər bölməsinə yaz. İldə bir-iki dəfə yenilə — bədən ölçüləri dəyişir. Bu vərdiş onlayn alış-verişi mağazadan asan edir.',
      },
      {
        type: 'p',
        text: 'Ölçü seçimində şübhən varsa, WhatsApp-dan yaza bilərsən — ölçülərini deyəndə konkret model üçün hansı ölçünün uyğun olduğunu deyirik.',
      },
    ],
  },

  {
    slug: 'parca-novleri-viskoz-pambiq-ketan',
    title: 'Viskoz, pambıq, kətan, polyester: hansı nə vaxt yaxşıdır',
    category: 'Parça',
    date: '2026-08-28',
    excerpt:
      'Etiketdəki tərkib paltarın necə geyiləcəyini, necə yuyulacağını və nə qədər davam edəcəyini müəyyən edir. Dörd əsas parçanın real fərqləri.',
    body: [
      {
        type: 'p',
        text: 'Paltarı seçəndə əvvəl rəngə və kəsimə baxırıq, tərkibə isə ən sonda — ya da heç. Halbuki etiketdəki bir sətir paltarın yayda necə olacağını, bir neçə yumadan sonra formasını saxlayıb-saxlamayacağını əvvəlcədən deyir.',
      },
      { type: 'h', text: 'Pambıq' },
      {
        type: 'p',
        text: 'Nəfəs alır, dəriyə yumşaqdır, allergiya vermir. Bakı yayının rütubətində rahatdır. Mənfi tərəfi: asanlıqla qırışır və ilk yumadan sonra bir az çəkə bilər. Ona görə keyfiyyətli pambıq məmulatlar əvvəlcədən emal olunur. Gündəlik geyim, köynək, yay donları üçün ən etibarlı seçimdir.',
      },
      { type: 'h', text: 'Viskoz' },
      {
        type: 'p',
        text: 'Selülozdan alınır, yəni təbii xammaldan, amma emal olunmuş parçadır. İpəyə bənzər axıcılığı var, bədənə gözəl oturur, qırışmır. Rəngi yaxşı saxlayır. Mənfi tərəfi: yaş halda zəifləyir, ona görə güclü sıxmaq və ya bir yerdən çəkib qurutmaq parçanı deformasiya edir. Don və bluzlarda çox istifadə olunur — məhz axıcı görüntü ona görədir.',
      },
      { type: 'h', text: 'Kətan' },
      {
        type: 'p',
        text: 'İstiliyi ən yaxşı buraxan parçadır — yay üçün ideal. Vaxt keçdikcə yumşalır və daha da rahat olur. Qırışır və bu, qüsur deyil, kətanın təbiətidir; müasir dizaynda bu, üslub kimi qəbul edilir. Əgər qırışmış görüntü səni narahat edirsə, kətan-viskoz qarışığı seç — qırışma xeyli azalır.',
      },
      { type: 'h', text: 'Polyester' },
      {
        type: 'p',
        text: 'Süni liftdir. Üstünlükləri real: qırışmır, formasını saxlayır, tez qurur, ucuzdur. Çatışmazlığı da real: nəfəs almır. Bakıda iyul-avqustda 100% polyester don geyinmək rahat deyil. Amma qış paltolarında, astarlarda və qarışıq tərkiblərdə (məsələn 30% polyester + 70% viskoz) faydalıdır — parçanı davamlı edir.',
      },
      {
        type: 'q',
        text: 'Qarışıq tərkib pis əlamət deyil. Əksinə, yaxşı qarışıq hər liftin üstün tərəfini birləşdirir: pambığın nəfəs alması + polyesterin form saxlaması.',
      },
      { type: 'h', text: 'Etiketi necə oxumaq' },
      {
        type: 'ul',
        items: [
          'Yay üçün: pambıq və ya kətan payı 60%-dən çox olsun.',
          'Axıcı, bədənə oturan don üçün: viskoz payı yüksək olan parça.',
          'Ofis köynəyi üçün: pambıq + bir az elastan (qırışmasın, hərəkət etsin).',
          'Qış üçün: yun payı olan qarışıqlar, astarlı modellər.',
        ],
      },
    ],
  },

  {
    slug: 'paltar-qullugu-yumaq-qurutmaq',
    title: 'Paltarı iki dəfə uzun geyinmək: qulluğun əsasları',
    category: 'Qulluq',
    date: '2026-08-14',
    excerpt:
      'Çoxu paltar köhnəldiyi üçün deyil, səhv yuyulduğu üçün geyilməz olur. Parça növünə görə temperatur, rejim və qurutma qaydaları.',
    body: [
      {
        type: 'p',
        text: 'Bir paltarın ömrünü ən çox qısaldan şey istifadə deyil, yumadır. Yüksək temperatur, güclü sıxma və düz günəşdə qurutma — üçü birlikdə yaxşı parçanı bir mövsümdə bitirir.',
      },
      { type: 'h', text: 'Temperatur' },
      {
        type: 'p',
        text: 'Rəngli paltarlar üçün 30 dərəcə kifayətdir. Müasir yuyucu vasitələr soyuq suda da işləyir. 40 dərəcədən yuxarı yalnız ağ pambıq üçün mənalıdır. Viskoz və ipək üçün 30 dərəcə maksimumdur — daha yüksəkdə parça çəkir və parlaqlığını itirir.',
      },
      { type: 'h', text: 'Sıxma' },
      {
        type: 'p',
        text: 'Bu, ən çox nəzərə alınmayan parametrdir. 1200 dövr/dəq viskoz və trikotaj üçün çox yüksəkdir — parça uzanır və forma pozulur. Zərif paltarlar üçün 600-ə endir. Daha uzun qurusa da, paltar formasını saxlayacaq.',
      },
      { type: 'h', text: 'Qurutma' },
      {
        type: 'ul',
        items: [
          'Trikotaj və sviterləri asma — çiyinləri uzanır. Düz səthdə, yayılmış vəziyyətdə qurut.',
          'Rəngli paltarları düz günəşdə qurutma. Bakıda yay günəşi bir neçə dəfədən sonra rəngi gözə görünəcək dərəcədə açır.',
          'Viskoz paltarları nəm halda asıb formasını əllə düzəlt — ütü ehtiyacı xeyli azalır.',
          'Quruducu maşın pambıq üçün də riskdir: çəkməyə ən çox səbəb odur.',
        ],
      },
      { type: 'h', text: 'Saxlama' },
      {
        type: 'p',
        text: 'Ağır palto və gödəkçələri geniş, yumşaq çiyinli asqılara as — nazik dəmir asqı çiyində iz buraxır. Trikotajı asmaq yerinə qatla. Mövsümi paltarları yığanda təmiz yığ: gözə görünməyən tər və parfüm ləkələri vaxt keçdikcə sarı ləkəyə çevrilir.',
      },
      {
        type: 'q',
        text: 'Qayda sadədir: nə qədər az temperatur, nə qədər az mexaniki güc — o qədər uzun ömür.',
      },
      { type: 'h', text: 'Ləkə ilə nə etmək' },
      {
        type: 'p',
        text: 'Ləkəni dərhal soyuq su ilə arxa tərəfdən yaxala. Sürtmə — yaymış olursan. İsti su bəzi ləkələri (xüsusilə zülal əsaslı olanları) parçaya sabitləyir. Yağ ləkəsinə bir az maye qabyuyan vur, 10 dəqiqə saxla, sonra yu.',
      },
    ],
  },

  {
    slug: 'kapsul-qarderob-baki-iqlimi',
    title: 'Bakı iqlimi üçün kapsul qarderob: 14 parça, bir mövsüm',
    category: 'Üslub',
    date: '2026-07-30',
    excerpt:
      'Dolu şkaf, amma geyinməyə heç nə yoxdur — tanış hissdir. Kapsul qarderob bu problemi paltar sayını artırmaqla deyil, azaltmaqla həll edir.',
    body: [
      {
        type: 'p',
        text: 'Kapsul qarderob bir-biri ilə uyğunlaşan məhdud sayda parçadan ibarət dəstdir. Məqsəd az geyinmək deyil — hər səhər seçim etməyə vaxt itirməmək və hər parçanın bir neçə kombinasiyada işləməsi.',
      },
      { type: 'h', text: 'Niyə Bakı üçün ayrıca düşünmək lazımdır' },
      {
        type: 'p',
        text: 'Bakının iqlimi iki xüsusiyyətə görə qarderoba təsir edir: rütubət və külək. Rütubət nəfəs almayan parçaları yayda geyilməz edir. Külək isə payız-qışda temperaturdan daha çox hiss olunur — ona görə qat-qat geyinmək (layering) burada dörd mövsüm işləyir.',
      },
      { type: 'h', text: 'Baza: 14 parça' },
      {
        type: 'ul',
        items: [
          'Neytral rəngli düz şalvar — hər şeylə gedir',
          'Tünd cins şalvar',
          'Ağ və ya krem köynək — pambıq',
          'İki sadə mayka və ya top',
          'Qara midi don — gündüz də, axşam da',
          'Naxışlı və ya rəngli bir don — özü üçün',
          'Nazik trikotaj sviter',
          'Kardiqan — qat üçün',
          'Klassik pencək (blazer)',
          'Yüngül trençkot — Bakının payızı üçün əsas parça',
          'Qış paltosu',
          'Midi yubka',
          'Rahat ağ krossovka',
          'Sadə ayaqqabı və ya dolğun daban',
        ],
      },
      { type: 'h', text: 'Rəng strategiyası' },
      {
        type: 'p',
        text: 'Parçaların 70–80%-i neytral olsun: qara, boz, krem, tünd göy, bej. Qalan 20% isə vurğu rəngləri — sənə yaraşan bir-iki ton. Bu nisbət kombinasiya sayını kəskin artırır: neytral parçalar bir-biri ilə həmişə uyğunlaşır, vurğu rəngi isə hər dəfə fərqli görüntü verir.',
      },
      {
        type: 'q',
        text: 'Bir parçanı alanda özünə bir sual ver: bunu şkafımdakı ən azı üç parça ilə geyinə bilərəmmi? Cavab yoxsa, o parça şkafda qalacaq.',
      },
      { type: 'h', text: 'Necə başlamaq' },
      {
        type: 'p',
        text: 'Hər şeyi birdən almaq lazım deyil. Şkafını aç, son üç ayda geyindiyin hər şeyi bir tərəfə yığ — real qarderobun elə odur. Sonra siyahıdakı çatışmayan parçaları tədricən əlavə et. Bir ayda 2–3 parça tempi kifayətdir.',
      },
    ],
  },

  {
    slug: 'beden-tipine-gore-don-secimi',
    title: 'Bədən tipinə görə don seçimi: hansı kəsim nəyi vurğulayır',
    category: 'Bələdçi',
    date: '2026-07-16',
    excerpt:
      'Eyni don iki fərqli adamda tamam başqa görünür. Səbəb keyfiyyət deyil, kəsimdir. Hansı kəsimin nə etdiyini bilmək seçimi asanlaşdırır.',
    body: [
      {
        type: 'p',
        text: 'Don alarkən ən çox eşidilən şikayət budur: "modeldə gözəl idi, mənə olmadı". Bu, adətən ölçü problemi deyil — kəsim problemidir. Hər kəsim bədənin müəyyən hissəsini vurğulayır və müəyyən hissəsini yumşaldır.',
      },
      { type: 'h', text: 'Kəsimlərin işi' },
      {
        type: 'ul',
        items: [
          'A-siluet (yuxarısı dar, aşağısı genişlənən): omba nahiyəsini yumşaldır, beli vurğulayır. Ən universal kəsimdir.',
          'Düz kəsim (shift): bədən xətlərini göstərmir, rahatdır. Uzun boylularda daha effektlidir.',
          'Bel vurğulu (fit-and-flare): qum saatı effekti yaradır. Beli nazik olanlarda ən yaxşı işləyir.',
          'Wrap (bağlamalı): beli tənzimlənən yeganə kəsim — ona görə ən çox bədən tipinə uyğun gəlir.',
          'Bodycon (bədənə oturan): bütün xətləri göstərir. Parçanın keyfiyyəti burada həlledicidir — nazik parça hər şeyi büruzə verir.',
        ],
      },
      { type: 'h', text: 'Yaxa xətti nə edir' },
      {
        type: 'p',
        text: 'V yaxa boynu uzun göstərir və yuxarı hissəni yüngülləşdirir. Qayıq yaxa (boat neck) çiyinləri genişləndirir — omba geniş olanda balans yaradır. Yüksək yaxa isə diqqəti üzə toplayır, amma qısa boyunda boynu daha da qısa göstərir.',
      },
      { type: 'h', text: 'Uzunluq' },
      {
        type: 'p',
        text: 'Midi uzunluq (dizdən aşağı, topuqdan yuxarı) ən çox bədən tipində işləyir, amma bir şərtlə: don ayağın ən nazik yerində bitməlidir. Ayağın ən qalın hissəsində bitən don həmin nöqtəni vurğulayır. Ona görə midi don alarkən öz boyuna görə uzunluğu yoxla — 165 sm üçün ideal olan uzunluq 175 sm-də tamam başqa yerə düşür.',
      },
      {
        type: 'q',
        text: 'Ən yaxşı kəsim jurnalda ən çox yazılan deyil — güzgüdə özünü rahat hiss etdiyin kəsimdir.',
      },
      {
        type: 'p',
        text: 'Şübhə qalarsa, ölçülərinizi WhatsApp-dan göndərin — konkret modelin sizdə necə oturacağını deyə bilərik.',
      },
    ],
  },

  {
    slug: 'reng-kombinasiyalari-praktik',
    title: 'Rəng kombinasiyası: yadda saxlamalı beş qayda',
    category: 'Üslub',
    date: '2026-06-28',
    excerpt:
      'Rəng nəzəriyyəsi mürəkkəb görünür, amma gündəlik geyimdə beş praktik qayda kifayət edir.',
    body: [
      {
        type: 'p',
        text: 'Rəng seçimi zövq məsələsidir, amma bir neçə obyektiv qayda var — onları biləndə səhv etmək çətinləşir.',
      },
      { type: 'h', text: '1. Neytral + bir vurğu' },
      {
        type: 'p',
        text: 'Ən etibarlı formula. Qara, boz, bej, krem, tünd göy — bunlar bir-biri ilə həmişə uyğun gəlir. Üstünə bir parlaq rəng əlavə edirsən və görüntü hazırdır. İki və daha çox parlaq rəng balansı pozur.',
      },
      { type: 'h', text: '2. Bir rəngin tonları (monoxrom)' },
      {
        type: 'p',
        text: 'Eyni rəngin fərqli tonları — açıq bej + tünd qəhvəyi, açıq göy + tünd göy. Bu, boyu uzun göstərir və həmişə səliqəli görünür. Ofis üçün ən sürətli həlldir.',
      },
      { type: 'h', text: '3. Qonşu rənglər' },
      {
        type: 'p',
        text: 'Rəng dairəsində yanaşı duran rənglər — göy və yaşıl, sarı və narıncı, bənövşəyi və çəhrayı. Yumşaq, təbii keçid verir. Risk azdır.',
      },
      { type: 'h', text: '4. Əks rənglər — ehtiyatla' },
      {
        type: 'p',
        text: 'Göy-narıncı, qırmızı-yaşıl kimi kontrastlar güclü effekt verir, amma asanlıqla ağırlaşır. Qayda: birini əsas, digərini kiçik detal kimi işlət — məsələn çanta və ya şərf.',
      },
      { type: 'h', text: '5. Öz dəri tonunu nəzərə al' },
      {
        type: 'p',
        text: 'Soyuq alt tonlu dəridə (damarlar mavi görünür) göy, bənövşəyi, gümüşü daha yaxşı oturur. İsti alt tonda (damarlar yaşılımtıl) bej, xardal, mərcan, qızılı işləyir. Bu, "hansı rəng gözəldir" sualı deyil — hansı rəngin üzü canlandırdığı sualıdır.',
      },
      {
        type: 'q',
        text: 'Şübhə varsa, üç rəngdən çox işlətmə. Ayaqqabı və çanta da rəng sayılır.',
      },
    ],
  },
];

/** Təxmini oxu müddəti (dəqiqə) */
export const readingTime = (post) => {
  const words = post.body.reduce((sum, block) => {
    if (block.type === 'ul') {
      return sum + block.items.join(' ').split(/\s+/).length;
    }
    return sum + String(block.text || '').split(/\s+/).length;
  }, 0);
  return Math.max(1, Math.round(words / 180));
};

/** 2026-09-12 -> 12 sentyabr 2026 */
export const formatDate = (iso) => {
  const months = [
    'yanvar', 'fevral', 'mart', 'aprel', 'may', 'iyun',
    'iyul', 'avqust', 'sentyabr', 'oktyabr', 'noyabr', 'dekabr',
  ];
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
};

export const getPostBySlug = (slug) => blogPosts.find((p) => p.slug === slug);

export default blogPosts;
